export const apiURL = "https://webapi.partcommunity.com/";
export const apiKey = "79ebb96234c04bd794d9f90e10f5192c";
export const language = "german";
export const catalog = "liebherr_components";
